import { render, staticRenderFns } from "./order.vue?vue&type=template&id=984ca438&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=984ca438&prod&lang=scss&scoped=true"
import style1 from "./order.vue?vue&type=style&index=1&id=984ca438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ca438",
  null
  
)

export default component.exports